import React__default from 'react';
import { InputCore } from '../shared/components/Input.mjs';
import { Button } from './Button.mjs';
import { CopyableText } from './CopyableText.mjs';
import { Label } from './Label.mjs';
import { Typography } from './Typography.mjs';
import outlinedInputClasses from '../../../../../node_modules/@mui/material/OutlinedInput/outlinedInputClasses.mjs';

const LabelBody1 = (props)=>/*#__PURE__*/ React__default.createElement(Label, {
        variant: "body1",
        ...props
    });
const inputSx = {
    color: (theme)=>theme.styleConfig.inputs.textColor,
    fontSize: (theme)=>theme.typography.body2.fontSize,
    borderRadius: (theme)=>theme.styleConfig.inputs.borderRadius,
    borderColor: (theme)=>theme.styleConfig.inputs.borderColor,
    backgroundColor: (theme)=>theme.styleConfig.inputs.backgroundColor,
    [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderRadius: (theme)=>theme.styleConfig.inputs.borderRadius,
        borderColor: (theme)=>theme.styleConfig.inputs.borderColor
    },
    [`& .${outlinedInputClasses.input}`]: {
        '&::placeholder': {
            color: (theme)=>theme.styleConfig.inputs.placeholderColor
        }
    },
    [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: (theme)=>theme.styleConfig.inputs.borderColor
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}, &.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: (theme)=>theme.styleConfig.inputs.textColor
    },
    [`&.${outlinedInputClasses.error}`]: {
        color: (theme)=>theme.styleConfig.colors.error
    }
};
const Input = ({ labelVariant, ...props })=>{
    return /*#__PURE__*/ React__default.createElement(InputCore, {
        ...props,
        ButtonComponent: Button,
        CopyableTextComponent: CopyableText,
        LabelComponent: labelVariant === 'body1' ? LabelBody1 : Label,
        TypographyComponent: Typography,
        inputSx: inputSx
    });
};

export { Input };
//# sourceMappingURL=Input.mjs.map
